<template>
  <div>
    <VcUpsellBlock :class="{'image-resize': asset === 'thryv'}"
                   :mode="blockMode"
                   :image-url="image"
                   v-bind="upsellProps"
                   icon="$check_circle_fill"
                   @buttonClick="goToUpgrade"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MarketingUpgradePage",
  props: {
    mode: {
      type: String,
      required: true,
      validator: prop => ['page', 'dialog'].includes(prop)
    },
    asset: {
      type: String,
      required: false,
    }
  },
  created() {
    const source = this.isDialog ? 'dialog' : 'page';
    this.$track(`Marketing blocking ${source} view`);
  },
  computed: {
    ...mapGetters(['isMobile']),
    image() {
      let filename;

      switch (this.asset) {
        case 'thryv':
          filename = 'marketing_upgrade_dialog_thryv.png';
          break;
        case 'pro-templates':
          filename = 'pro_campaigns.png';
          break;
        default:
          filename = this.isDialog ? 'marketing_upgrade_dialog.png' : 'marketing_upgrade_page.png';
          break;
      }

      return require(`@/assets/images/${filename}`);
    },
    blockMode() {
      return this.isMobile ? "dialog" : this.mode;
    },
    isDialog() {
      return this.mode === 'dialog'
    },
    upsellProps() {
      return this.asset === 'thryv' ? {
        titleText: this.$t('campaign_template.marketing_upgrade.thryv.title'),
        subtitleText: this.$t('campaign_template.marketing_upgrade.thryv.subtitle_new'),
        bulletsText: [
          this.$t('campaign_template.marketing_upgrade.thryv.bullets.a_new'),
          this.$t('campaign_template.marketing_upgrade.thryv.bullets.b_new'),
          this.$t('campaign_template.marketing_upgrade.thryv.bullets.c_new')
        ],
        buttonText: this.$t('campaign_template.marketing_upgrade.thryv.button_new'),
        linkText: "",
        linkUrl: 'https://www.thryv.com/pricing/'
    } : {
        titleText: this.$t('campaign_template.marketing_upgrade.title'),
        subtitleText: this.$t('campaign_template.marketing_upgrade.subtitle'),
        bulletsText: [
          this.$t('campaign_template.marketing_upgrade.bullets.a'),
          this.$t('campaign_template.marketing_upgrade.bullets.b'),
          this.$t('campaign_template.marketing_upgrade.bullets.c')
        ],
        buttonText: this.$t('campaign_template.marketing_upgrade.button')
      };
    }
  },
  methods: {
    goToUpgrade() {
      this.$track('Upgrade CTA is clicked');
      this.$emit('close');

      if (this.asset === 'thryv') {
        this.$frontageApi.openExternal('https://business-center-upgrade.labs.thryv.com/purchase-addon/pro-editor');
      } else {
        this.$frontageApi.send('upgrade-action');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-resize {

  &:before {
    inset-inline-start: 55% !important;
    z-index: -1;
  }

  ::v-deep .upsell-image {
    height: 380px !important;
    inset-inline-start: -30px !important;
    transform: rotate(2deg);
  }
}
</style>
